module.exports = __webpack_public_path__ + "img/far-envelope.dab31c00.svg";